import { Control } from "react-hook-form";
import { ControlledSelectV2 } from "@/components/ui/customs/controlled-select-v2";
import { PickupZoneFormData } from "@/types/forms/bo/pickupZone.form";
import { usePickupTimeOptions } from "@/hooks/useEnumOptions";
import { useTranslation } from "react-i18next";

type PickupTimeRowProps = {
  control: Control<PickupZoneFormData>;
  index: number;
  dayLabel: string;
};

export const PickupTimeRow = ({ control, index, dayLabel }: PickupTimeRowProps) => {
  const { t } = useTranslation("boLogistics");
  const pickupTimeOptions = usePickupTimeOptions();

  return (
    <div className="flex w-full flex-row items-center gap-4">
      <span className="text-sm font-medium text-gray-700">{dayLabel}</span>
      <ControlledSelectV2
        options={pickupTimeOptions}
        control={control}
        name={`pickupDays.${index}.pickupTime`}
        placeholder={t("zoneEditModal.pickupTimePlaceholder")}
        wrapperClassName="w-full"
      />
    </div>
  );
};
